export enum TokenType {
  FIREBASE = "firebase",
  MICROSOFT = "microsoft",
}
